<template>
    <div class="exportCase" style="display: inline-block;">
        <el-button style="margin: 0 10px;" type="primary" plain round :size="buttonSize" @click="showAlert($event)">导出</el-button>
    
        <el-dialog title="提示" width="440px" center :visible.sync="alertVisible" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false" append-to-body :before-close="onBeforeClose" destroy-on-close>
            <div class="alert_box" v-if="alertVisible" :key="componentKey">
                <p>确认<b style="color: #F56C6C;">导出最新数据</b>？还是<b style="color: #F56C6C;">历史导出过的数据</b>？</p>
                <p>导出最新数据：即 反应当前时间最新的数据，速度较慢。</p>
                <p>导出历史数据：即 上次相同条件的历史数据，速度较快。</p>
                <span class="footer_box" slot="footer">
                    <el-button type="primary" :size="buttonSize" @click="onExport($event, 1)">导出最新数据</el-button>
                    <el-button type="primary" :size="buttonSize" @click="onExport($event, 2)">导出历史数据</el-button>
                </span>
            </div>
        </el-dialog>

        <el-dialog title="提示" width="440px" center :visible.sync="successVisible" :close-on-click-modal="false" :close-on-press-escape="false" :modal-append-to-body="false" append-to-body :before-close="onBeforeClose" destroy-on-close>
            <div class="alert_box" v-if="successVisible" :key="componentKey">
                <p ><b style="color: #67C23A;">导出申请已提交</b></p>
                <p>正在为您准备可导出的数据，导出单个文件最多支持5万条，多出部分会被自动拆分，您可以点击顶部「<b class="on">导出记录</b>」查看结果并下载。</p>
                <span class="footer_box" slot="footer">
                    <el-button type="primary" :size="buttonSize" @click="onBeforeClose">确定</el-button>
                </span>
            </div>
        </el-dialog>

        <transition name="move" @before-enter="beforeMove" @enter="onMoving" @after-enter="afterMove">
            <div class="moveCase" v-show="moveJson.state">
                <div class="moveDom el-icon-folder-opened"></div>
            </div>
        </transition>
   
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import envConfig  from '@/common/env'

export default {
    props: {
        exportTableList: { //页面列表table数据
            type: Array,
            default: () => [],
        },
        exportUrl: { //页面列表导出地址
            type: String,
            default: null,
        },
        exportParams: { //页面列表导出参数
            type: Object,
            default: () => {},
        },
        exportArrToStr: { //exportParams中 array 类型转换成 string 类型
            type: Object,
            default: () => {},
        },
        buttonSize: { //【导出】按钮大小 medium / small / mini
            type: String,
            default: "small",
        },
    },
    data () {
        return {
            fullscreen: true,//true=全屏；false=不是全屏；
            componentKey: null,
            alertVisible: false,
            successVisible: false,
            moveJson: { state: false, dom: null },
            successPath: null,
        }
    },
    computed: {
        newTableList() {
            return this.exportTableList || [];
        },
        newUrl() {
            return `${envConfig.marbasUrl}/rescue-master/marbas/api/export/dispatch/${this.exportUrl}`;
        },
        newParams() {
            let json = this.exportParams || {};
            let to = this.exportArrToStr || {};
            for(let i in to) {
                json[i] = to[i] && to[i].length ? to[i].join(",") : null;
            }
            return json;
        },
    },
    created () {
        
    },
    mounted () {
        
    },
    methods: {
        onInit(e, freshExport) {
            let url = JSON.parse(JSON.stringify(this.newUrl));
            let params = JSON.parse(JSON.stringify(this.newParams));
            this.successPath =  null;
            // console.log("参数->", params)
            // return;
            this.$axios.post(url, { freshExport, qo: params }).then((res) => {
                // console.log(res)
				let { code, data, msg } = this.AppUtils.checkResponse(res);
                if(code == 0 && data) {
                    let { historyExportStatus, exportPath } = data;
                    if(historyExportStatus == 0 || historyExportStatus == null) {
                        this.$eventBus.$emit("sendExportClick", {state: true});
                        return this.onExport(e);
                    } else if(historyExportStatus == 1) {
                        return this.$message.warning("数据正在导出中，您可以点击顶部「导出记录」查看结果。");
                    } else if(historyExportStatus == 2) {
                        this.componentKey = Date.now();
                        this.alertVisible = true;
                        this.successPath = exportPath;
                    } else if(historyExportStatus == 3) {
                        return this.$message.error("数据导出失败");
                    }
                } else {
                    this.$message.error(msg);
                }
			})
        },

        showAlert(e) {
            let tableList = JSON.parse(JSON.stringify(this.newTableList));
            if (tableList.length < 1) {
				return this.$message.error("暂无可导出数据～");
			}
            this.onInit(e, 0);
        },
        
        onExport(e, n) {
            let _this = this;
            if(n == 1) {
                return this.onInit(e, 1);
            } else if(n == 2) {
                this.onBeforeClose();
                return window.open(`${this.successPath}`, "_blank");
            }
            this.onMove(e.target);
            setTimeout(() => {
                _this.onSuccess();
            }, 100)
        },

        onSuccess() {
            this.componentKey = Date.now();
            this.successVisible = true;
        },

        onBeforeClose() {
            this.alertVisible = false;
            this.successVisible = false; 
        },

        // 动画效果
        onMove(el) { // 借鉴demo https://www.cnblogs.com/pengfei25/p/11736427.html
            this.moveJson = { state: true, dom: el };
        },
        beforeMove(el) {
            let { state, dom } = this.moveJson;
            if(state) {
                let { x, y } = dom.getBoundingClientRect();
                x = x + 16;
                el.style.display = '';
                el.style.webkitTransform = `translate(${x}px, ${y}px)`;
                el.style.transform = `translate(${x}px, ${y}px)`;
                let moveDom = el.getElementsByClassName('moveDom')[0];
                moveDom.style.webkitTransform = `translate(${x}px, ${y}px)`;
                moveDom.style.transform = `translate(${x}px, ${y}px)`;
            }
        },
        onMoving(el, done) {
            this.$nextTick(() => {
                const moveEnd = document.getElementById('message_box').getBoundingClientRect();
                el.style.webkitTransform = 'translate(0, 0)';
                el.style.transform = 'translate(0, 0)';
                let moveDom = el.getElementsByClassName('moveDom')[0];
                moveDom.style.webkitTransform = `translate(${moveEnd.left}px, ${moveEnd.top}px)`;
                moveDom.style.transform =`translate(${moveEnd.left}px, ${moveEnd.top}px)`;
                el.addEventListener('transitionend', done);
            })
        },
        afterMove(el) {
            this.moveJson = { state: false, dom: null };
            el.style.display = 'none';
        },

    }
}
</script>

<style scoped>
    .alert_box p {
        line-height: 25px;
    }
    .footer_box {
        margin: 30px 0 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .on {
        text-decoration: underline;
        color: #409EFF;
        /* cursor: pointer; */
    }

    .moveCase {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }
    .moveDom {
        width: 32px;
        height: 32px;
        font-size: 23px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: #409EFF;
        background: #F2F6FC;
        transition: all 1s linear;
    }
</style>


// WEBPACK FOOTER //
// exportButton.vue?8f8fb35e